/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as InviteRouteImport } from './routes/invite'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as UserRouteImport } from './routes/_user'
import { Route as DashboardRouteRouteImport } from './routes/dashboard/route'
import { Route as AffiliateRouteRouteImport } from './routes/affiliate/route'
import { Route as AdminV2RouteRouteImport } from './routes/admin-v2/route'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as CareerPageIndexRouteImport } from './routes/career-page/index'
import { Route as AffiliateIndexRouteImport } from './routes/affiliate/index'
import { Route as AdminV2IndexRouteImport } from './routes/admin-v2/index'
import { Route as AboutUsIndexRouteImport } from './routes/about-us/index'
import { Route as HomeLandingIndexRouteImport } from './routes/_home-landing/index'
import { Route as JobDetailJobIdRouteImport } from './routes/job-detail/$jobId'
import { Route as DashboardPersonalInformationRouteImport } from './routes/dashboard/personal-information'
import { Route as DashboardLicenseRouteImport } from './routes/dashboard/license'
import { Route as DashboardLanguagesRouteImport } from './routes/dashboard/languages'
import { Route as DashboardJobHistoryRouteImport } from './routes/dashboard/job-history'
import { Route as DashboardExperienceRouteImport } from './routes/dashboard/experience'
import { Route as DashboardEducationRouteImport } from './routes/dashboard/education'
import { Route as AuthVerificationRouteImport } from './routes/auth/verification'
import { Route as AuthRegisterRouteImport } from './routes/auth/register'
import { Route as AuthPhoneRouteImport } from './routes/auth/phone'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as AuthForgotPasswordRouteImport } from './routes/auth/forgot-password'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as AuthSplatRouteImport } from './routes/auth/$'
import { Route as AffiliateHistoryRouteImport } from './routes/affiliate/history'
import { Route as UserProfileRouteImport } from './routes/_user/profile'
import { Route as ProgramGijinkokuPreparationIndexRouteImport } from './routes/program/gijinkoku-preparation/index'
import { Route as AdminV2ReferralIndexRouteImport } from './routes/admin-v2/referral/index'
import { Route as AdminV2ParticipantIndexRouteImport } from './routes/admin-v2/participant/index'
import { Route as UserProfileIndexRouteImport } from './routes/_user/profile/index'
import { Route as AuthVerificationSuccessRouteImport } from './routes/auth/verification.success'
import { Route as AuthVerificationPhoneRouteImport } from './routes/auth/verification.phone'
import { Route as AuthVerificationOtpRouteImport } from './routes/auth/verification.otp'
import { Route as AuthNewPasswordTokenRouteImport } from './routes/auth/new-password.$token'
import { Route as AdminV2ReferralPointHistoryRouteImport } from './routes/admin-v2/referral/point-history'
import { Route as AdminV2ReferralIdRouteImport } from './routes/admin-v2/referral/$id'
import { Route as UserProfilePersonalRouteImport } from './routes/_user/profile/personal'
import { Route as UserProfileLicencesRouteImport } from './routes/_user/profile/licences'
import { Route as UserProfileLanguagesRouteImport } from './routes/_user/profile/languages'
import { Route as UserProfileExperienceRouteImport } from './routes/_user/profile/experience'
import { Route as UserProfileEducationRouteImport } from './routes/_user/profile/education'
import { Route as UserDigishokuProfileRouteImport } from './routes/_user/digishoku/profile'
import { Route as UserDigishokuDashboardRouteImport } from './routes/_user/digishoku/dashboard'
import { Route as UserAccountEditRouteImport } from './routes/_user/account.edit'
import { Route as AdminV2ParticipantParticipantIdIndexRouteImport } from './routes/admin-v2/participant/$participantId/index'
import { Route as AdminV2MasterTagIndexRouteImport } from './routes/admin-v2/master/tag/index'
import { Route as AdminV2MasterSkillIndexRouteImport } from './routes/admin-v2/master/skill/index'
import { Route as AdminV2MasterSchemaIndexRouteImport } from './routes/admin-v2/master/schema/index'
import { Route as AdminV2MasterCompanyIndexRouteImport } from './routes/admin-v2/master/company/index'
import { Route as AdminV2MasterCategoryIndexRouteImport } from './routes/admin-v2/master/category/index'
import { Route as AdminV2JobVacancyIndexRouteImport } from './routes/admin-v2/job/vacancy/index'
import { Route as AdminV2JobApplicantIndexRouteImport } from './routes/admin-v2/job/applicant/index'
import { Route as UserDigishokuProfileIndexRouteImport } from './routes/_user/digishoku/profile/index'
import { Route as AdminV2MasterCompanyCreateRouteImport } from './routes/admin-v2/master/company/create'
import { Route as AdminV2MasterCompanyIdRouteImport } from './routes/admin-v2/master/company/$id'
import { Route as AdminV2JobVacancyCreateRouteImport } from './routes/admin-v2/job/vacancy/create'
import { Route as UserDigishokuProfileLanguagesRouteImport } from './routes/_user/digishoku/profile/languages'
import { Route as UserDigishokuProfileExperienceRouteImport } from './routes/_user/digishoku/profile/experience'
import { Route as UserDigishokuProfileEducationRouteImport } from './routes/_user/digishoku/profile/education'
import { Route as UserDigishokuProfileAttachmentRouteImport } from './routes/_user/digishoku/profile/attachment'
import { Route as UserDigishokuAccountEditRouteImport } from './routes/_user/digishoku/account.edit'
import { Route as AdminV2JobVacancyIdIndexRouteImport } from './routes/admin-v2/job/vacancy/$id.index'
import { Route as AdminV2JobApplicantVacancyIndexRouteImport } from './routes/admin-v2/job/applicant/vacancy/index'
import { Route as AdminV2JobApplicantApplicantIdIndexRouteImport } from './routes/admin-v2/job/applicant/$applicantId/index'
import { Route as AdminV2JobVacancyIdEditRouteImport } from './routes/admin-v2/job/vacancy/$id.edit'
import { Route as AdminV2JobApplicantVacancyJobIdIndexRouteImport } from './routes/admin-v2/job/applicant/vacancy/$jobId/index'

const InviteRoute = InviteRouteImport.update({
  id: '/invite',
  path: '/invite',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const UserRoute = UserRouteImport.update({
  id: '/_user',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRouteRoute = DashboardRouteRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const AffiliateRouteRoute = AffiliateRouteRouteImport.update({
  id: '/affiliate',
  path: '/affiliate',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminV2RouteRoute = AdminV2RouteRouteImport.update({
  id: '/admin-v2',
  path: '/admin-v2',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const CareerPageIndexRoute = CareerPageIndexRouteImport.update({
  id: '/career-page/',
  path: '/career-page/',
  getParentRoute: () => rootRouteImport,
} as any)
const AffiliateIndexRoute = AffiliateIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AffiliateRouteRoute,
} as any)
const AdminV2IndexRoute = AdminV2IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminV2RouteRoute,
} as any)
const AboutUsIndexRoute = AboutUsIndexRouteImport.update({
  id: '/about-us/',
  path: '/about-us/',
  getParentRoute: () => rootRouteImport,
} as any)
const HomeLandingIndexRoute = HomeLandingIndexRouteImport.update({
  id: '/_home-landing/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const JobDetailJobIdRoute = JobDetailJobIdRouteImport.update({
  id: '/job-detail/$jobId',
  path: '/job-detail/$jobId',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardPersonalInformationRoute =
  DashboardPersonalInformationRouteImport.update({
    id: '/personal-information',
    path: '/personal-information',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardLicenseRoute = DashboardLicenseRouteImport.update({
  id: '/license',
  path: '/license',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardLanguagesRoute = DashboardLanguagesRouteImport.update({
  id: '/languages',
  path: '/languages',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardJobHistoryRoute = DashboardJobHistoryRouteImport.update({
  id: '/job-history',
  path: '/job-history',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardExperienceRoute = DashboardExperienceRouteImport.update({
  id: '/experience',
  path: '/experience',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardEducationRoute = DashboardEducationRouteImport.update({
  id: '/education',
  path: '/education',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const AuthVerificationRoute = AuthVerificationRouteImport.update({
  id: '/verification',
  path: '/verification',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRegisterRoute = AuthRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPhoneRoute = AuthPhoneRouteImport.update({
  id: '/phone',
  path: '/phone',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSplatRoute = AuthSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => AuthRoute,
} as any)
const AffiliateHistoryRoute = AffiliateHistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => AffiliateRouteRoute,
} as any)
const UserProfileRoute = UserProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => UserRoute,
} as any)
const ProgramGijinkokuPreparationIndexRoute =
  ProgramGijinkokuPreparationIndexRouteImport.update({
    id: '/program/gijinkoku-preparation/',
    path: '/program/gijinkoku-preparation/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminV2ReferralIndexRoute = AdminV2ReferralIndexRouteImport.update({
  id: '/referral/',
  path: '/referral/',
  getParentRoute: () => AdminV2RouteRoute,
} as any)
const AdminV2ParticipantIndexRoute = AdminV2ParticipantIndexRouteImport.update({
  id: '/participant/',
  path: '/participant/',
  getParentRoute: () => AdminV2RouteRoute,
} as any)
const UserProfileIndexRoute = UserProfileIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => UserProfileRoute,
} as any)
const AuthVerificationSuccessRoute = AuthVerificationSuccessRouteImport.update({
  id: '/success',
  path: '/success',
  getParentRoute: () => AuthVerificationRoute,
} as any)
const AuthVerificationPhoneRoute = AuthVerificationPhoneRouteImport.update({
  id: '/phone',
  path: '/phone',
  getParentRoute: () => AuthVerificationRoute,
} as any)
const AuthVerificationOtpRoute = AuthVerificationOtpRouteImport.update({
  id: '/otp',
  path: '/otp',
  getParentRoute: () => AuthVerificationRoute,
} as any)
const AuthNewPasswordTokenRoute = AuthNewPasswordTokenRouteImport.update({
  id: '/new-password/$token',
  path: '/new-password/$token',
  getParentRoute: () => AuthRoute,
} as any)
const AdminV2ReferralPointHistoryRoute =
  AdminV2ReferralPointHistoryRouteImport.update({
    id: '/referral/point-history',
    path: '/referral/point-history',
    getParentRoute: () => AdminV2RouteRoute,
  } as any)
const AdminV2ReferralIdRoute = AdminV2ReferralIdRouteImport.update({
  id: '/referral/$id',
  path: '/referral/$id',
  getParentRoute: () => AdminV2RouteRoute,
} as any)
const UserProfilePersonalRoute = UserProfilePersonalRouteImport.update({
  id: '/personal',
  path: '/personal',
  getParentRoute: () => UserProfileRoute,
} as any)
const UserProfileLicencesRoute = UserProfileLicencesRouteImport.update({
  id: '/licences',
  path: '/licences',
  getParentRoute: () => UserProfileRoute,
} as any)
const UserProfileLanguagesRoute = UserProfileLanguagesRouteImport.update({
  id: '/languages',
  path: '/languages',
  getParentRoute: () => UserProfileRoute,
} as any)
const UserProfileExperienceRoute = UserProfileExperienceRouteImport.update({
  id: '/experience',
  path: '/experience',
  getParentRoute: () => UserProfileRoute,
} as any)
const UserProfileEducationRoute = UserProfileEducationRouteImport.update({
  id: '/education',
  path: '/education',
  getParentRoute: () => UserProfileRoute,
} as any)
const UserDigishokuProfileRoute = UserDigishokuProfileRouteImport.update({
  id: '/digishoku/profile',
  path: '/digishoku/profile',
  getParentRoute: () => UserRoute,
} as any)
const UserDigishokuDashboardRoute = UserDigishokuDashboardRouteImport.update({
  id: '/digishoku/dashboard',
  path: '/digishoku/dashboard',
  getParentRoute: () => UserRoute,
} as any)
const UserAccountEditRoute = UserAccountEditRouteImport.update({
  id: '/account/edit',
  path: '/account/edit',
  getParentRoute: () => UserRoute,
} as any)
const AdminV2ParticipantParticipantIdIndexRoute =
  AdminV2ParticipantParticipantIdIndexRouteImport.update({
    id: '/participant/$participantId/',
    path: '/participant/$participantId/',
    getParentRoute: () => AdminV2RouteRoute,
  } as any)
const AdminV2MasterTagIndexRoute = AdminV2MasterTagIndexRouteImport.update({
  id: '/master/tag/',
  path: '/master/tag/',
  getParentRoute: () => AdminV2RouteRoute,
} as any)
const AdminV2MasterSkillIndexRoute = AdminV2MasterSkillIndexRouteImport.update({
  id: '/master/skill/',
  path: '/master/skill/',
  getParentRoute: () => AdminV2RouteRoute,
} as any)
const AdminV2MasterSchemaIndexRoute =
  AdminV2MasterSchemaIndexRouteImport.update({
    id: '/master/schema/',
    path: '/master/schema/',
    getParentRoute: () => AdminV2RouteRoute,
  } as any)
const AdminV2MasterCompanyIndexRoute =
  AdminV2MasterCompanyIndexRouteImport.update({
    id: '/master/company/',
    path: '/master/company/',
    getParentRoute: () => AdminV2RouteRoute,
  } as any)
const AdminV2MasterCategoryIndexRoute =
  AdminV2MasterCategoryIndexRouteImport.update({
    id: '/master/category/',
    path: '/master/category/',
    getParentRoute: () => AdminV2RouteRoute,
  } as any)
const AdminV2JobVacancyIndexRoute = AdminV2JobVacancyIndexRouteImport.update({
  id: '/job/vacancy/',
  path: '/job/vacancy/',
  getParentRoute: () => AdminV2RouteRoute,
} as any)
const AdminV2JobApplicantIndexRoute =
  AdminV2JobApplicantIndexRouteImport.update({
    id: '/job/applicant/',
    path: '/job/applicant/',
    getParentRoute: () => AdminV2RouteRoute,
  } as any)
const UserDigishokuProfileIndexRoute =
  UserDigishokuProfileIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => UserDigishokuProfileRoute,
  } as any)
const AdminV2MasterCompanyCreateRoute =
  AdminV2MasterCompanyCreateRouteImport.update({
    id: '/master/company/create',
    path: '/master/company/create',
    getParentRoute: () => AdminV2RouteRoute,
  } as any)
const AdminV2MasterCompanyIdRoute = AdminV2MasterCompanyIdRouteImport.update({
  id: '/master/company/$id',
  path: '/master/company/$id',
  getParentRoute: () => AdminV2RouteRoute,
} as any)
const AdminV2JobVacancyCreateRoute = AdminV2JobVacancyCreateRouteImport.update({
  id: '/job/vacancy/create',
  path: '/job/vacancy/create',
  getParentRoute: () => AdminV2RouteRoute,
} as any)
const UserDigishokuProfileLanguagesRoute =
  UserDigishokuProfileLanguagesRouteImport.update({
    id: '/languages',
    path: '/languages',
    getParentRoute: () => UserDigishokuProfileRoute,
  } as any)
const UserDigishokuProfileExperienceRoute =
  UserDigishokuProfileExperienceRouteImport.update({
    id: '/experience',
    path: '/experience',
    getParentRoute: () => UserDigishokuProfileRoute,
  } as any)
const UserDigishokuProfileEducationRoute =
  UserDigishokuProfileEducationRouteImport.update({
    id: '/education',
    path: '/education',
    getParentRoute: () => UserDigishokuProfileRoute,
  } as any)
const UserDigishokuProfileAttachmentRoute =
  UserDigishokuProfileAttachmentRouteImport.update({
    id: '/attachment',
    path: '/attachment',
    getParentRoute: () => UserDigishokuProfileRoute,
  } as any)
const UserDigishokuAccountEditRoute =
  UserDigishokuAccountEditRouteImport.update({
    id: '/digishoku/account/edit',
    path: '/digishoku/account/edit',
    getParentRoute: () => UserRoute,
  } as any)
const AdminV2JobVacancyIdIndexRoute =
  AdminV2JobVacancyIdIndexRouteImport.update({
    id: '/job/vacancy/$id/',
    path: '/job/vacancy/$id/',
    getParentRoute: () => AdminV2RouteRoute,
  } as any)
const AdminV2JobApplicantVacancyIndexRoute =
  AdminV2JobApplicantVacancyIndexRouteImport.update({
    id: '/job/applicant/vacancy/',
    path: '/job/applicant/vacancy/',
    getParentRoute: () => AdminV2RouteRoute,
  } as any)
const AdminV2JobApplicantApplicantIdIndexRoute =
  AdminV2JobApplicantApplicantIdIndexRouteImport.update({
    id: '/job/applicant/$applicantId/',
    path: '/job/applicant/$applicantId/',
    getParentRoute: () => AdminV2RouteRoute,
  } as any)
const AdminV2JobVacancyIdEditRoute = AdminV2JobVacancyIdEditRouteImport.update({
  id: '/job/vacancy/$id/edit',
  path: '/job/vacancy/$id/edit',
  getParentRoute: () => AdminV2RouteRoute,
} as any)
const AdminV2JobApplicantVacancyJobIdIndexRoute =
  AdminV2JobApplicantVacancyJobIdIndexRouteImport.update({
    id: '/job/applicant/vacancy/$jobId/',
    path: '/job/applicant/vacancy/$jobId/',
    getParentRoute: () => AdminV2RouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/admin-v2': typeof AdminV2RouteRouteWithChildren
  '/affiliate': typeof AffiliateRouteRouteWithChildren
  '/dashboard': typeof DashboardRouteRouteWithChildren
  '/auth': typeof AuthRouteWithChildren
  '/invite': typeof InviteRoute
  '/profile': typeof UserProfileRouteWithChildren
  '/affiliate/history': typeof AffiliateHistoryRoute
  '/auth/$': typeof AuthSplatRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/phone': typeof AuthPhoneRoute
  '/auth/register': typeof AuthRegisterRoute
  '/auth/verification': typeof AuthVerificationRouteWithChildren
  '/dashboard/education': typeof DashboardEducationRoute
  '/dashboard/experience': typeof DashboardExperienceRoute
  '/dashboard/job-history': typeof DashboardJobHistoryRoute
  '/dashboard/languages': typeof DashboardLanguagesRoute
  '/dashboard/license': typeof DashboardLicenseRoute
  '/dashboard/personal-information': typeof DashboardPersonalInformationRoute
  '/job-detail/$jobId': typeof JobDetailJobIdRoute
  '/': typeof HomeLandingIndexRoute
  '/about-us': typeof AboutUsIndexRoute
  '/admin-v2/': typeof AdminV2IndexRoute
  '/affiliate/': typeof AffiliateIndexRoute
  '/career-page': typeof CareerPageIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/account/edit': typeof UserAccountEditRoute
  '/digishoku/dashboard': typeof UserDigishokuDashboardRoute
  '/digishoku/profile': typeof UserDigishokuProfileRouteWithChildren
  '/profile/education': typeof UserProfileEducationRoute
  '/profile/experience': typeof UserProfileExperienceRoute
  '/profile/languages': typeof UserProfileLanguagesRoute
  '/profile/licences': typeof UserProfileLicencesRoute
  '/profile/personal': typeof UserProfilePersonalRoute
  '/admin-v2/referral/$id': typeof AdminV2ReferralIdRoute
  '/admin-v2/referral/point-history': typeof AdminV2ReferralPointHistoryRoute
  '/auth/new-password/$token': typeof AuthNewPasswordTokenRoute
  '/auth/verification/otp': typeof AuthVerificationOtpRoute
  '/auth/verification/phone': typeof AuthVerificationPhoneRoute
  '/auth/verification/success': typeof AuthVerificationSuccessRoute
  '/profile/': typeof UserProfileIndexRoute
  '/admin-v2/participant': typeof AdminV2ParticipantIndexRoute
  '/admin-v2/referral': typeof AdminV2ReferralIndexRoute
  '/program/gijinkoku-preparation': typeof ProgramGijinkokuPreparationIndexRoute
  '/digishoku/account/edit': typeof UserDigishokuAccountEditRoute
  '/digishoku/profile/attachment': typeof UserDigishokuProfileAttachmentRoute
  '/digishoku/profile/education': typeof UserDigishokuProfileEducationRoute
  '/digishoku/profile/experience': typeof UserDigishokuProfileExperienceRoute
  '/digishoku/profile/languages': typeof UserDigishokuProfileLanguagesRoute
  '/admin-v2/job/vacancy/create': typeof AdminV2JobVacancyCreateRoute
  '/admin-v2/master/company/$id': typeof AdminV2MasterCompanyIdRoute
  '/admin-v2/master/company/create': typeof AdminV2MasterCompanyCreateRoute
  '/digishoku/profile/': typeof UserDigishokuProfileIndexRoute
  '/admin-v2/job/applicant': typeof AdminV2JobApplicantIndexRoute
  '/admin-v2/job/vacancy': typeof AdminV2JobVacancyIndexRoute
  '/admin-v2/master/category': typeof AdminV2MasterCategoryIndexRoute
  '/admin-v2/master/company': typeof AdminV2MasterCompanyIndexRoute
  '/admin-v2/master/schema': typeof AdminV2MasterSchemaIndexRoute
  '/admin-v2/master/skill': typeof AdminV2MasterSkillIndexRoute
  '/admin-v2/master/tag': typeof AdminV2MasterTagIndexRoute
  '/admin-v2/participant/$participantId': typeof AdminV2ParticipantParticipantIdIndexRoute
  '/admin-v2/job/vacancy/$id/edit': typeof AdminV2JobVacancyIdEditRoute
  '/admin-v2/job/applicant/$applicantId': typeof AdminV2JobApplicantApplicantIdIndexRoute
  '/admin-v2/job/applicant/vacancy': typeof AdminV2JobApplicantVacancyIndexRoute
  '/admin-v2/job/vacancy/$id': typeof AdminV2JobVacancyIdIndexRoute
  '/admin-v2/job/applicant/vacancy/$jobId': typeof AdminV2JobApplicantVacancyJobIdIndexRoute
}
export interface FileRoutesByTo {
  '/auth': typeof AuthRouteWithChildren
  '/invite': typeof InviteRoute
  '/affiliate/history': typeof AffiliateHistoryRoute
  '/auth/$': typeof AuthSplatRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/phone': typeof AuthPhoneRoute
  '/auth/register': typeof AuthRegisterRoute
  '/auth/verification': typeof AuthVerificationRouteWithChildren
  '/dashboard/education': typeof DashboardEducationRoute
  '/dashboard/experience': typeof DashboardExperienceRoute
  '/dashboard/job-history': typeof DashboardJobHistoryRoute
  '/dashboard/languages': typeof DashboardLanguagesRoute
  '/dashboard/license': typeof DashboardLicenseRoute
  '/dashboard/personal-information': typeof DashboardPersonalInformationRoute
  '/job-detail/$jobId': typeof JobDetailJobIdRoute
  '/': typeof HomeLandingIndexRoute
  '/about-us': typeof AboutUsIndexRoute
  '/admin-v2': typeof AdminV2IndexRoute
  '/affiliate': typeof AffiliateIndexRoute
  '/career-page': typeof CareerPageIndexRoute
  '/dashboard': typeof DashboardIndexRoute
  '/account/edit': typeof UserAccountEditRoute
  '/digishoku/dashboard': typeof UserDigishokuDashboardRoute
  '/profile/education': typeof UserProfileEducationRoute
  '/profile/experience': typeof UserProfileExperienceRoute
  '/profile/languages': typeof UserProfileLanguagesRoute
  '/profile/licences': typeof UserProfileLicencesRoute
  '/profile/personal': typeof UserProfilePersonalRoute
  '/admin-v2/referral/$id': typeof AdminV2ReferralIdRoute
  '/admin-v2/referral/point-history': typeof AdminV2ReferralPointHistoryRoute
  '/auth/new-password/$token': typeof AuthNewPasswordTokenRoute
  '/auth/verification/otp': typeof AuthVerificationOtpRoute
  '/auth/verification/phone': typeof AuthVerificationPhoneRoute
  '/auth/verification/success': typeof AuthVerificationSuccessRoute
  '/profile': typeof UserProfileIndexRoute
  '/admin-v2/participant': typeof AdminV2ParticipantIndexRoute
  '/admin-v2/referral': typeof AdminV2ReferralIndexRoute
  '/program/gijinkoku-preparation': typeof ProgramGijinkokuPreparationIndexRoute
  '/digishoku/account/edit': typeof UserDigishokuAccountEditRoute
  '/digishoku/profile/attachment': typeof UserDigishokuProfileAttachmentRoute
  '/digishoku/profile/education': typeof UserDigishokuProfileEducationRoute
  '/digishoku/profile/experience': typeof UserDigishokuProfileExperienceRoute
  '/digishoku/profile/languages': typeof UserDigishokuProfileLanguagesRoute
  '/admin-v2/job/vacancy/create': typeof AdminV2JobVacancyCreateRoute
  '/admin-v2/master/company/$id': typeof AdminV2MasterCompanyIdRoute
  '/admin-v2/master/company/create': typeof AdminV2MasterCompanyCreateRoute
  '/digishoku/profile': typeof UserDigishokuProfileIndexRoute
  '/admin-v2/job/applicant': typeof AdminV2JobApplicantIndexRoute
  '/admin-v2/job/vacancy': typeof AdminV2JobVacancyIndexRoute
  '/admin-v2/master/category': typeof AdminV2MasterCategoryIndexRoute
  '/admin-v2/master/company': typeof AdminV2MasterCompanyIndexRoute
  '/admin-v2/master/schema': typeof AdminV2MasterSchemaIndexRoute
  '/admin-v2/master/skill': typeof AdminV2MasterSkillIndexRoute
  '/admin-v2/master/tag': typeof AdminV2MasterTagIndexRoute
  '/admin-v2/participant/$participantId': typeof AdminV2ParticipantParticipantIdIndexRoute
  '/admin-v2/job/vacancy/$id/edit': typeof AdminV2JobVacancyIdEditRoute
  '/admin-v2/job/applicant/$applicantId': typeof AdminV2JobApplicantApplicantIdIndexRoute
  '/admin-v2/job/applicant/vacancy': typeof AdminV2JobApplicantVacancyIndexRoute
  '/admin-v2/job/vacancy/$id': typeof AdminV2JobVacancyIdIndexRoute
  '/admin-v2/job/applicant/vacancy/$jobId': typeof AdminV2JobApplicantVacancyJobIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/admin-v2': typeof AdminV2RouteRouteWithChildren
  '/affiliate': typeof AffiliateRouteRouteWithChildren
  '/dashboard': typeof DashboardRouteRouteWithChildren
  '/_user': typeof UserRouteWithChildren
  '/auth': typeof AuthRouteWithChildren
  '/invite': typeof InviteRoute
  '/_user/profile': typeof UserProfileRouteWithChildren
  '/affiliate/history': typeof AffiliateHistoryRoute
  '/auth/$': typeof AuthSplatRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/phone': typeof AuthPhoneRoute
  '/auth/register': typeof AuthRegisterRoute
  '/auth/verification': typeof AuthVerificationRouteWithChildren
  '/dashboard/education': typeof DashboardEducationRoute
  '/dashboard/experience': typeof DashboardExperienceRoute
  '/dashboard/job-history': typeof DashboardJobHistoryRoute
  '/dashboard/languages': typeof DashboardLanguagesRoute
  '/dashboard/license': typeof DashboardLicenseRoute
  '/dashboard/personal-information': typeof DashboardPersonalInformationRoute
  '/job-detail/$jobId': typeof JobDetailJobIdRoute
  '/_home-landing/': typeof HomeLandingIndexRoute
  '/about-us/': typeof AboutUsIndexRoute
  '/admin-v2/': typeof AdminV2IndexRoute
  '/affiliate/': typeof AffiliateIndexRoute
  '/career-page/': typeof CareerPageIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/_user/account/edit': typeof UserAccountEditRoute
  '/_user/digishoku/dashboard': typeof UserDigishokuDashboardRoute
  '/_user/digishoku/profile': typeof UserDigishokuProfileRouteWithChildren
  '/_user/profile/education': typeof UserProfileEducationRoute
  '/_user/profile/experience': typeof UserProfileExperienceRoute
  '/_user/profile/languages': typeof UserProfileLanguagesRoute
  '/_user/profile/licences': typeof UserProfileLicencesRoute
  '/_user/profile/personal': typeof UserProfilePersonalRoute
  '/admin-v2/referral/$id': typeof AdminV2ReferralIdRoute
  '/admin-v2/referral/point-history': typeof AdminV2ReferralPointHistoryRoute
  '/auth/new-password/$token': typeof AuthNewPasswordTokenRoute
  '/auth/verification/otp': typeof AuthVerificationOtpRoute
  '/auth/verification/phone': typeof AuthVerificationPhoneRoute
  '/auth/verification/success': typeof AuthVerificationSuccessRoute
  '/_user/profile/': typeof UserProfileIndexRoute
  '/admin-v2/participant/': typeof AdminV2ParticipantIndexRoute
  '/admin-v2/referral/': typeof AdminV2ReferralIndexRoute
  '/program/gijinkoku-preparation/': typeof ProgramGijinkokuPreparationIndexRoute
  '/_user/digishoku/account/edit': typeof UserDigishokuAccountEditRoute
  '/_user/digishoku/profile/attachment': typeof UserDigishokuProfileAttachmentRoute
  '/_user/digishoku/profile/education': typeof UserDigishokuProfileEducationRoute
  '/_user/digishoku/profile/experience': typeof UserDigishokuProfileExperienceRoute
  '/_user/digishoku/profile/languages': typeof UserDigishokuProfileLanguagesRoute
  '/admin-v2/job/vacancy/create': typeof AdminV2JobVacancyCreateRoute
  '/admin-v2/master/company/$id': typeof AdminV2MasterCompanyIdRoute
  '/admin-v2/master/company/create': typeof AdminV2MasterCompanyCreateRoute
  '/_user/digishoku/profile/': typeof UserDigishokuProfileIndexRoute
  '/admin-v2/job/applicant/': typeof AdminV2JobApplicantIndexRoute
  '/admin-v2/job/vacancy/': typeof AdminV2JobVacancyIndexRoute
  '/admin-v2/master/category/': typeof AdminV2MasterCategoryIndexRoute
  '/admin-v2/master/company/': typeof AdminV2MasterCompanyIndexRoute
  '/admin-v2/master/schema/': typeof AdminV2MasterSchemaIndexRoute
  '/admin-v2/master/skill/': typeof AdminV2MasterSkillIndexRoute
  '/admin-v2/master/tag/': typeof AdminV2MasterTagIndexRoute
  '/admin-v2/participant/$participantId/': typeof AdminV2ParticipantParticipantIdIndexRoute
  '/admin-v2/job/vacancy/$id/edit': typeof AdminV2JobVacancyIdEditRoute
  '/admin-v2/job/applicant/$applicantId/': typeof AdminV2JobApplicantApplicantIdIndexRoute
  '/admin-v2/job/applicant/vacancy/': typeof AdminV2JobApplicantVacancyIndexRoute
  '/admin-v2/job/vacancy/$id/': typeof AdminV2JobVacancyIdIndexRoute
  '/admin-v2/job/applicant/vacancy/$jobId/': typeof AdminV2JobApplicantVacancyJobIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/admin-v2'
    | '/affiliate'
    | '/dashboard'
    | '/auth'
    | '/invite'
    | '/profile'
    | '/affiliate/history'
    | '/auth/$'
    | '/auth/callback'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/phone'
    | '/auth/register'
    | '/auth/verification'
    | '/dashboard/education'
    | '/dashboard/experience'
    | '/dashboard/job-history'
    | '/dashboard/languages'
    | '/dashboard/license'
    | '/dashboard/personal-information'
    | '/job-detail/$jobId'
    | '/'
    | '/about-us'
    | '/admin-v2/'
    | '/affiliate/'
    | '/career-page'
    | '/dashboard/'
    | '/account/edit'
    | '/digishoku/dashboard'
    | '/digishoku/profile'
    | '/profile/education'
    | '/profile/experience'
    | '/profile/languages'
    | '/profile/licences'
    | '/profile/personal'
    | '/admin-v2/referral/$id'
    | '/admin-v2/referral/point-history'
    | '/auth/new-password/$token'
    | '/auth/verification/otp'
    | '/auth/verification/phone'
    | '/auth/verification/success'
    | '/profile/'
    | '/admin-v2/participant'
    | '/admin-v2/referral'
    | '/program/gijinkoku-preparation'
    | '/digishoku/account/edit'
    | '/digishoku/profile/attachment'
    | '/digishoku/profile/education'
    | '/digishoku/profile/experience'
    | '/digishoku/profile/languages'
    | '/admin-v2/job/vacancy/create'
    | '/admin-v2/master/company/$id'
    | '/admin-v2/master/company/create'
    | '/digishoku/profile/'
    | '/admin-v2/job/applicant'
    | '/admin-v2/job/vacancy'
    | '/admin-v2/master/category'
    | '/admin-v2/master/company'
    | '/admin-v2/master/schema'
    | '/admin-v2/master/skill'
    | '/admin-v2/master/tag'
    | '/admin-v2/participant/$participantId'
    | '/admin-v2/job/vacancy/$id/edit'
    | '/admin-v2/job/applicant/$applicantId'
    | '/admin-v2/job/applicant/vacancy'
    | '/admin-v2/job/vacancy/$id'
    | '/admin-v2/job/applicant/vacancy/$jobId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/auth'
    | '/invite'
    | '/affiliate/history'
    | '/auth/$'
    | '/auth/callback'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/phone'
    | '/auth/register'
    | '/auth/verification'
    | '/dashboard/education'
    | '/dashboard/experience'
    | '/dashboard/job-history'
    | '/dashboard/languages'
    | '/dashboard/license'
    | '/dashboard/personal-information'
    | '/job-detail/$jobId'
    | '/'
    | '/about-us'
    | '/admin-v2'
    | '/affiliate'
    | '/career-page'
    | '/dashboard'
    | '/account/edit'
    | '/digishoku/dashboard'
    | '/profile/education'
    | '/profile/experience'
    | '/profile/languages'
    | '/profile/licences'
    | '/profile/personal'
    | '/admin-v2/referral/$id'
    | '/admin-v2/referral/point-history'
    | '/auth/new-password/$token'
    | '/auth/verification/otp'
    | '/auth/verification/phone'
    | '/auth/verification/success'
    | '/profile'
    | '/admin-v2/participant'
    | '/admin-v2/referral'
    | '/program/gijinkoku-preparation'
    | '/digishoku/account/edit'
    | '/digishoku/profile/attachment'
    | '/digishoku/profile/education'
    | '/digishoku/profile/experience'
    | '/digishoku/profile/languages'
    | '/admin-v2/job/vacancy/create'
    | '/admin-v2/master/company/$id'
    | '/admin-v2/master/company/create'
    | '/digishoku/profile'
    | '/admin-v2/job/applicant'
    | '/admin-v2/job/vacancy'
    | '/admin-v2/master/category'
    | '/admin-v2/master/company'
    | '/admin-v2/master/schema'
    | '/admin-v2/master/skill'
    | '/admin-v2/master/tag'
    | '/admin-v2/participant/$participantId'
    | '/admin-v2/job/vacancy/$id/edit'
    | '/admin-v2/job/applicant/$applicantId'
    | '/admin-v2/job/applicant/vacancy'
    | '/admin-v2/job/vacancy/$id'
    | '/admin-v2/job/applicant/vacancy/$jobId'
  id:
    | '__root__'
    | '/admin-v2'
    | '/affiliate'
    | '/dashboard'
    | '/_user'
    | '/auth'
    | '/invite'
    | '/_user/profile'
    | '/affiliate/history'
    | '/auth/$'
    | '/auth/callback'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/phone'
    | '/auth/register'
    | '/auth/verification'
    | '/dashboard/education'
    | '/dashboard/experience'
    | '/dashboard/job-history'
    | '/dashboard/languages'
    | '/dashboard/license'
    | '/dashboard/personal-information'
    | '/job-detail/$jobId'
    | '/_home-landing/'
    | '/about-us/'
    | '/admin-v2/'
    | '/affiliate/'
    | '/career-page/'
    | '/dashboard/'
    | '/_user/account/edit'
    | '/_user/digishoku/dashboard'
    | '/_user/digishoku/profile'
    | '/_user/profile/education'
    | '/_user/profile/experience'
    | '/_user/profile/languages'
    | '/_user/profile/licences'
    | '/_user/profile/personal'
    | '/admin-v2/referral/$id'
    | '/admin-v2/referral/point-history'
    | '/auth/new-password/$token'
    | '/auth/verification/otp'
    | '/auth/verification/phone'
    | '/auth/verification/success'
    | '/_user/profile/'
    | '/admin-v2/participant/'
    | '/admin-v2/referral/'
    | '/program/gijinkoku-preparation/'
    | '/_user/digishoku/account/edit'
    | '/_user/digishoku/profile/attachment'
    | '/_user/digishoku/profile/education'
    | '/_user/digishoku/profile/experience'
    | '/_user/digishoku/profile/languages'
    | '/admin-v2/job/vacancy/create'
    | '/admin-v2/master/company/$id'
    | '/admin-v2/master/company/create'
    | '/_user/digishoku/profile/'
    | '/admin-v2/job/applicant/'
    | '/admin-v2/job/vacancy/'
    | '/admin-v2/master/category/'
    | '/admin-v2/master/company/'
    | '/admin-v2/master/schema/'
    | '/admin-v2/master/skill/'
    | '/admin-v2/master/tag/'
    | '/admin-v2/participant/$participantId/'
    | '/admin-v2/job/vacancy/$id/edit'
    | '/admin-v2/job/applicant/$applicantId/'
    | '/admin-v2/job/applicant/vacancy/'
    | '/admin-v2/job/vacancy/$id/'
    | '/admin-v2/job/applicant/vacancy/$jobId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AdminV2RouteRoute: typeof AdminV2RouteRouteWithChildren
  AffiliateRouteRoute: typeof AffiliateRouteRouteWithChildren
  DashboardRouteRoute: typeof DashboardRouteRouteWithChildren
  UserRoute: typeof UserRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  InviteRoute: typeof InviteRoute
  JobDetailJobIdRoute: typeof JobDetailJobIdRoute
  HomeLandingIndexRoute: typeof HomeLandingIndexRoute
  AboutUsIndexRoute: typeof AboutUsIndexRoute
  CareerPageIndexRoute: typeof CareerPageIndexRoute
  ProgramGijinkokuPreparationIndexRoute: typeof ProgramGijinkokuPreparationIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/invite': {
      id: '/invite'
      path: '/invite'
      fullPath: '/invite'
      preLoaderRoute: typeof InviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_user': {
      id: '/_user'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof UserRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/affiliate': {
      id: '/affiliate'
      path: '/affiliate'
      fullPath: '/affiliate'
      preLoaderRoute: typeof AffiliateRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin-v2': {
      id: '/admin-v2'
      path: '/admin-v2'
      fullPath: '/admin-v2'
      preLoaderRoute: typeof AdminV2RouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/career-page/': {
      id: '/career-page/'
      path: '/career-page'
      fullPath: '/career-page'
      preLoaderRoute: typeof CareerPageIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/affiliate/': {
      id: '/affiliate/'
      path: '/'
      fullPath: '/affiliate/'
      preLoaderRoute: typeof AffiliateIndexRouteImport
      parentRoute: typeof AffiliateRouteRoute
    }
    '/admin-v2/': {
      id: '/admin-v2/'
      path: '/'
      fullPath: '/admin-v2/'
      preLoaderRoute: typeof AdminV2IndexRouteImport
      parentRoute: typeof AdminV2RouteRoute
    }
    '/about-us/': {
      id: '/about-us/'
      path: '/about-us'
      fullPath: '/about-us'
      preLoaderRoute: typeof AboutUsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_home-landing/': {
      id: '/_home-landing/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof HomeLandingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/job-detail/$jobId': {
      id: '/job-detail/$jobId'
      path: '/job-detail/$jobId'
      fullPath: '/job-detail/$jobId'
      preLoaderRoute: typeof JobDetailJobIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/personal-information': {
      id: '/dashboard/personal-information'
      path: '/personal-information'
      fullPath: '/dashboard/personal-information'
      preLoaderRoute: typeof DashboardPersonalInformationRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/license': {
      id: '/dashboard/license'
      path: '/license'
      fullPath: '/dashboard/license'
      preLoaderRoute: typeof DashboardLicenseRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/languages': {
      id: '/dashboard/languages'
      path: '/languages'
      fullPath: '/dashboard/languages'
      preLoaderRoute: typeof DashboardLanguagesRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/job-history': {
      id: '/dashboard/job-history'
      path: '/job-history'
      fullPath: '/dashboard/job-history'
      preLoaderRoute: typeof DashboardJobHistoryRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/experience': {
      id: '/dashboard/experience'
      path: '/experience'
      fullPath: '/dashboard/experience'
      preLoaderRoute: typeof DashboardExperienceRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/education': {
      id: '/dashboard/education'
      path: '/education'
      fullPath: '/dashboard/education'
      preLoaderRoute: typeof DashboardEducationRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/auth/verification': {
      id: '/auth/verification'
      path: '/verification'
      fullPath: '/auth/verification'
      preLoaderRoute: typeof AuthVerificationRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/register': {
      id: '/auth/register'
      path: '/register'
      fullPath: '/auth/register'
      preLoaderRoute: typeof AuthRegisterRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/phone': {
      id: '/auth/phone'
      path: '/phone'
      fullPath: '/auth/phone'
      preLoaderRoute: typeof AuthPhoneRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/forgot-password': {
      id: '/auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/auth/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/$': {
      id: '/auth/$'
      path: '/$'
      fullPath: '/auth/$'
      preLoaderRoute: typeof AuthSplatRouteImport
      parentRoute: typeof AuthRoute
    }
    '/affiliate/history': {
      id: '/affiliate/history'
      path: '/history'
      fullPath: '/affiliate/history'
      preLoaderRoute: typeof AffiliateHistoryRouteImport
      parentRoute: typeof AffiliateRouteRoute
    }
    '/_user/profile': {
      id: '/_user/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof UserProfileRouteImport
      parentRoute: typeof UserRoute
    }
    '/program/gijinkoku-preparation/': {
      id: '/program/gijinkoku-preparation/'
      path: '/program/gijinkoku-preparation'
      fullPath: '/program/gijinkoku-preparation'
      preLoaderRoute: typeof ProgramGijinkokuPreparationIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin-v2/referral/': {
      id: '/admin-v2/referral/'
      path: '/referral'
      fullPath: '/admin-v2/referral'
      preLoaderRoute: typeof AdminV2ReferralIndexRouteImport
      parentRoute: typeof AdminV2RouteRoute
    }
    '/admin-v2/participant/': {
      id: '/admin-v2/participant/'
      path: '/participant'
      fullPath: '/admin-v2/participant'
      preLoaderRoute: typeof AdminV2ParticipantIndexRouteImport
      parentRoute: typeof AdminV2RouteRoute
    }
    '/_user/profile/': {
      id: '/_user/profile/'
      path: '/'
      fullPath: '/profile/'
      preLoaderRoute: typeof UserProfileIndexRouteImport
      parentRoute: typeof UserProfileRoute
    }
    '/auth/verification/success': {
      id: '/auth/verification/success'
      path: '/success'
      fullPath: '/auth/verification/success'
      preLoaderRoute: typeof AuthVerificationSuccessRouteImport
      parentRoute: typeof AuthVerificationRoute
    }
    '/auth/verification/phone': {
      id: '/auth/verification/phone'
      path: '/phone'
      fullPath: '/auth/verification/phone'
      preLoaderRoute: typeof AuthVerificationPhoneRouteImport
      parentRoute: typeof AuthVerificationRoute
    }
    '/auth/verification/otp': {
      id: '/auth/verification/otp'
      path: '/otp'
      fullPath: '/auth/verification/otp'
      preLoaderRoute: typeof AuthVerificationOtpRouteImport
      parentRoute: typeof AuthVerificationRoute
    }
    '/auth/new-password/$token': {
      id: '/auth/new-password/$token'
      path: '/new-password/$token'
      fullPath: '/auth/new-password/$token'
      preLoaderRoute: typeof AuthNewPasswordTokenRouteImport
      parentRoute: typeof AuthRoute
    }
    '/admin-v2/referral/point-history': {
      id: '/admin-v2/referral/point-history'
      path: '/referral/point-history'
      fullPath: '/admin-v2/referral/point-history'
      preLoaderRoute: typeof AdminV2ReferralPointHistoryRouteImport
      parentRoute: typeof AdminV2RouteRoute
    }
    '/admin-v2/referral/$id': {
      id: '/admin-v2/referral/$id'
      path: '/referral/$id'
      fullPath: '/admin-v2/referral/$id'
      preLoaderRoute: typeof AdminV2ReferralIdRouteImport
      parentRoute: typeof AdminV2RouteRoute
    }
    '/_user/profile/personal': {
      id: '/_user/profile/personal'
      path: '/personal'
      fullPath: '/profile/personal'
      preLoaderRoute: typeof UserProfilePersonalRouteImport
      parentRoute: typeof UserProfileRoute
    }
    '/_user/profile/licences': {
      id: '/_user/profile/licences'
      path: '/licences'
      fullPath: '/profile/licences'
      preLoaderRoute: typeof UserProfileLicencesRouteImport
      parentRoute: typeof UserProfileRoute
    }
    '/_user/profile/languages': {
      id: '/_user/profile/languages'
      path: '/languages'
      fullPath: '/profile/languages'
      preLoaderRoute: typeof UserProfileLanguagesRouteImport
      parentRoute: typeof UserProfileRoute
    }
    '/_user/profile/experience': {
      id: '/_user/profile/experience'
      path: '/experience'
      fullPath: '/profile/experience'
      preLoaderRoute: typeof UserProfileExperienceRouteImport
      parentRoute: typeof UserProfileRoute
    }
    '/_user/profile/education': {
      id: '/_user/profile/education'
      path: '/education'
      fullPath: '/profile/education'
      preLoaderRoute: typeof UserProfileEducationRouteImport
      parentRoute: typeof UserProfileRoute
    }
    '/_user/digishoku/profile': {
      id: '/_user/digishoku/profile'
      path: '/digishoku/profile'
      fullPath: '/digishoku/profile'
      preLoaderRoute: typeof UserDigishokuProfileRouteImport
      parentRoute: typeof UserRoute
    }
    '/_user/digishoku/dashboard': {
      id: '/_user/digishoku/dashboard'
      path: '/digishoku/dashboard'
      fullPath: '/digishoku/dashboard'
      preLoaderRoute: typeof UserDigishokuDashboardRouteImport
      parentRoute: typeof UserRoute
    }
    '/_user/account/edit': {
      id: '/_user/account/edit'
      path: '/account/edit'
      fullPath: '/account/edit'
      preLoaderRoute: typeof UserAccountEditRouteImport
      parentRoute: typeof UserRoute
    }
    '/admin-v2/participant/$participantId/': {
      id: '/admin-v2/participant/$participantId/'
      path: '/participant/$participantId'
      fullPath: '/admin-v2/participant/$participantId'
      preLoaderRoute: typeof AdminV2ParticipantParticipantIdIndexRouteImport
      parentRoute: typeof AdminV2RouteRoute
    }
    '/admin-v2/master/tag/': {
      id: '/admin-v2/master/tag/'
      path: '/master/tag'
      fullPath: '/admin-v2/master/tag'
      preLoaderRoute: typeof AdminV2MasterTagIndexRouteImport
      parentRoute: typeof AdminV2RouteRoute
    }
    '/admin-v2/master/skill/': {
      id: '/admin-v2/master/skill/'
      path: '/master/skill'
      fullPath: '/admin-v2/master/skill'
      preLoaderRoute: typeof AdminV2MasterSkillIndexRouteImport
      parentRoute: typeof AdminV2RouteRoute
    }
    '/admin-v2/master/schema/': {
      id: '/admin-v2/master/schema/'
      path: '/master/schema'
      fullPath: '/admin-v2/master/schema'
      preLoaderRoute: typeof AdminV2MasterSchemaIndexRouteImport
      parentRoute: typeof AdminV2RouteRoute
    }
    '/admin-v2/master/company/': {
      id: '/admin-v2/master/company/'
      path: '/master/company'
      fullPath: '/admin-v2/master/company'
      preLoaderRoute: typeof AdminV2MasterCompanyIndexRouteImport
      parentRoute: typeof AdminV2RouteRoute
    }
    '/admin-v2/master/category/': {
      id: '/admin-v2/master/category/'
      path: '/master/category'
      fullPath: '/admin-v2/master/category'
      preLoaderRoute: typeof AdminV2MasterCategoryIndexRouteImport
      parentRoute: typeof AdminV2RouteRoute
    }
    '/admin-v2/job/vacancy/': {
      id: '/admin-v2/job/vacancy/'
      path: '/job/vacancy'
      fullPath: '/admin-v2/job/vacancy'
      preLoaderRoute: typeof AdminV2JobVacancyIndexRouteImport
      parentRoute: typeof AdminV2RouteRoute
    }
    '/admin-v2/job/applicant/': {
      id: '/admin-v2/job/applicant/'
      path: '/job/applicant'
      fullPath: '/admin-v2/job/applicant'
      preLoaderRoute: typeof AdminV2JobApplicantIndexRouteImport
      parentRoute: typeof AdminV2RouteRoute
    }
    '/_user/digishoku/profile/': {
      id: '/_user/digishoku/profile/'
      path: '/'
      fullPath: '/digishoku/profile/'
      preLoaderRoute: typeof UserDigishokuProfileIndexRouteImport
      parentRoute: typeof UserDigishokuProfileRoute
    }
    '/admin-v2/master/company/create': {
      id: '/admin-v2/master/company/create'
      path: '/master/company/create'
      fullPath: '/admin-v2/master/company/create'
      preLoaderRoute: typeof AdminV2MasterCompanyCreateRouteImport
      parentRoute: typeof AdminV2RouteRoute
    }
    '/admin-v2/master/company/$id': {
      id: '/admin-v2/master/company/$id'
      path: '/master/company/$id'
      fullPath: '/admin-v2/master/company/$id'
      preLoaderRoute: typeof AdminV2MasterCompanyIdRouteImport
      parentRoute: typeof AdminV2RouteRoute
    }
    '/admin-v2/job/vacancy/create': {
      id: '/admin-v2/job/vacancy/create'
      path: '/job/vacancy/create'
      fullPath: '/admin-v2/job/vacancy/create'
      preLoaderRoute: typeof AdminV2JobVacancyCreateRouteImport
      parentRoute: typeof AdminV2RouteRoute
    }
    '/_user/digishoku/profile/languages': {
      id: '/_user/digishoku/profile/languages'
      path: '/languages'
      fullPath: '/digishoku/profile/languages'
      preLoaderRoute: typeof UserDigishokuProfileLanguagesRouteImport
      parentRoute: typeof UserDigishokuProfileRoute
    }
    '/_user/digishoku/profile/experience': {
      id: '/_user/digishoku/profile/experience'
      path: '/experience'
      fullPath: '/digishoku/profile/experience'
      preLoaderRoute: typeof UserDigishokuProfileExperienceRouteImport
      parentRoute: typeof UserDigishokuProfileRoute
    }
    '/_user/digishoku/profile/education': {
      id: '/_user/digishoku/profile/education'
      path: '/education'
      fullPath: '/digishoku/profile/education'
      preLoaderRoute: typeof UserDigishokuProfileEducationRouteImport
      parentRoute: typeof UserDigishokuProfileRoute
    }
    '/_user/digishoku/profile/attachment': {
      id: '/_user/digishoku/profile/attachment'
      path: '/attachment'
      fullPath: '/digishoku/profile/attachment'
      preLoaderRoute: typeof UserDigishokuProfileAttachmentRouteImport
      parentRoute: typeof UserDigishokuProfileRoute
    }
    '/_user/digishoku/account/edit': {
      id: '/_user/digishoku/account/edit'
      path: '/digishoku/account/edit'
      fullPath: '/digishoku/account/edit'
      preLoaderRoute: typeof UserDigishokuAccountEditRouteImport
      parentRoute: typeof UserRoute
    }
    '/admin-v2/job/vacancy/$id/': {
      id: '/admin-v2/job/vacancy/$id/'
      path: '/job/vacancy/$id'
      fullPath: '/admin-v2/job/vacancy/$id'
      preLoaderRoute: typeof AdminV2JobVacancyIdIndexRouteImport
      parentRoute: typeof AdminV2RouteRoute
    }
    '/admin-v2/job/applicant/vacancy/': {
      id: '/admin-v2/job/applicant/vacancy/'
      path: '/job/applicant/vacancy'
      fullPath: '/admin-v2/job/applicant/vacancy'
      preLoaderRoute: typeof AdminV2JobApplicantVacancyIndexRouteImport
      parentRoute: typeof AdminV2RouteRoute
    }
    '/admin-v2/job/applicant/$applicantId/': {
      id: '/admin-v2/job/applicant/$applicantId/'
      path: '/job/applicant/$applicantId'
      fullPath: '/admin-v2/job/applicant/$applicantId'
      preLoaderRoute: typeof AdminV2JobApplicantApplicantIdIndexRouteImport
      parentRoute: typeof AdminV2RouteRoute
    }
    '/admin-v2/job/vacancy/$id/edit': {
      id: '/admin-v2/job/vacancy/$id/edit'
      path: '/job/vacancy/$id/edit'
      fullPath: '/admin-v2/job/vacancy/$id/edit'
      preLoaderRoute: typeof AdminV2JobVacancyIdEditRouteImport
      parentRoute: typeof AdminV2RouteRoute
    }
    '/admin-v2/job/applicant/vacancy/$jobId/': {
      id: '/admin-v2/job/applicant/vacancy/$jobId/'
      path: '/job/applicant/vacancy/$jobId'
      fullPath: '/admin-v2/job/applicant/vacancy/$jobId'
      preLoaderRoute: typeof AdminV2JobApplicantVacancyJobIdIndexRouteImport
      parentRoute: typeof AdminV2RouteRoute
    }
  }
}

interface AdminV2RouteRouteChildren {
  AdminV2IndexRoute: typeof AdminV2IndexRoute
  AdminV2ReferralIdRoute: typeof AdminV2ReferralIdRoute
  AdminV2ReferralPointHistoryRoute: typeof AdminV2ReferralPointHistoryRoute
  AdminV2ParticipantIndexRoute: typeof AdminV2ParticipantIndexRoute
  AdminV2ReferralIndexRoute: typeof AdminV2ReferralIndexRoute
  AdminV2JobVacancyCreateRoute: typeof AdminV2JobVacancyCreateRoute
  AdminV2MasterCompanyIdRoute: typeof AdminV2MasterCompanyIdRoute
  AdminV2MasterCompanyCreateRoute: typeof AdminV2MasterCompanyCreateRoute
  AdminV2JobApplicantIndexRoute: typeof AdminV2JobApplicantIndexRoute
  AdminV2JobVacancyIndexRoute: typeof AdminV2JobVacancyIndexRoute
  AdminV2MasterCategoryIndexRoute: typeof AdminV2MasterCategoryIndexRoute
  AdminV2MasterCompanyIndexRoute: typeof AdminV2MasterCompanyIndexRoute
  AdminV2MasterSchemaIndexRoute: typeof AdminV2MasterSchemaIndexRoute
  AdminV2MasterSkillIndexRoute: typeof AdminV2MasterSkillIndexRoute
  AdminV2MasterTagIndexRoute: typeof AdminV2MasterTagIndexRoute
  AdminV2ParticipantParticipantIdIndexRoute: typeof AdminV2ParticipantParticipantIdIndexRoute
  AdminV2JobVacancyIdEditRoute: typeof AdminV2JobVacancyIdEditRoute
  AdminV2JobApplicantApplicantIdIndexRoute: typeof AdminV2JobApplicantApplicantIdIndexRoute
  AdminV2JobApplicantVacancyIndexRoute: typeof AdminV2JobApplicantVacancyIndexRoute
  AdminV2JobVacancyIdIndexRoute: typeof AdminV2JobVacancyIdIndexRoute
  AdminV2JobApplicantVacancyJobIdIndexRoute: typeof AdminV2JobApplicantVacancyJobIdIndexRoute
}

const AdminV2RouteRouteChildren: AdminV2RouteRouteChildren = {
  AdminV2IndexRoute: AdminV2IndexRoute,
  AdminV2ReferralIdRoute: AdminV2ReferralIdRoute,
  AdminV2ReferralPointHistoryRoute: AdminV2ReferralPointHistoryRoute,
  AdminV2ParticipantIndexRoute: AdminV2ParticipantIndexRoute,
  AdminV2ReferralIndexRoute: AdminV2ReferralIndexRoute,
  AdminV2JobVacancyCreateRoute: AdminV2JobVacancyCreateRoute,
  AdminV2MasterCompanyIdRoute: AdminV2MasterCompanyIdRoute,
  AdminV2MasterCompanyCreateRoute: AdminV2MasterCompanyCreateRoute,
  AdminV2JobApplicantIndexRoute: AdminV2JobApplicantIndexRoute,
  AdminV2JobVacancyIndexRoute: AdminV2JobVacancyIndexRoute,
  AdminV2MasterCategoryIndexRoute: AdminV2MasterCategoryIndexRoute,
  AdminV2MasterCompanyIndexRoute: AdminV2MasterCompanyIndexRoute,
  AdminV2MasterSchemaIndexRoute: AdminV2MasterSchemaIndexRoute,
  AdminV2MasterSkillIndexRoute: AdminV2MasterSkillIndexRoute,
  AdminV2MasterTagIndexRoute: AdminV2MasterTagIndexRoute,
  AdminV2ParticipantParticipantIdIndexRoute:
    AdminV2ParticipantParticipantIdIndexRoute,
  AdminV2JobVacancyIdEditRoute: AdminV2JobVacancyIdEditRoute,
  AdminV2JobApplicantApplicantIdIndexRoute:
    AdminV2JobApplicantApplicantIdIndexRoute,
  AdminV2JobApplicantVacancyIndexRoute: AdminV2JobApplicantVacancyIndexRoute,
  AdminV2JobVacancyIdIndexRoute: AdminV2JobVacancyIdIndexRoute,
  AdminV2JobApplicantVacancyJobIdIndexRoute:
    AdminV2JobApplicantVacancyJobIdIndexRoute,
}

const AdminV2RouteRouteWithChildren = AdminV2RouteRoute._addFileChildren(
  AdminV2RouteRouteChildren,
)

interface AffiliateRouteRouteChildren {
  AffiliateHistoryRoute: typeof AffiliateHistoryRoute
  AffiliateIndexRoute: typeof AffiliateIndexRoute
}

const AffiliateRouteRouteChildren: AffiliateRouteRouteChildren = {
  AffiliateHistoryRoute: AffiliateHistoryRoute,
  AffiliateIndexRoute: AffiliateIndexRoute,
}

const AffiliateRouteRouteWithChildren = AffiliateRouteRoute._addFileChildren(
  AffiliateRouteRouteChildren,
)

interface DashboardRouteRouteChildren {
  DashboardEducationRoute: typeof DashboardEducationRoute
  DashboardExperienceRoute: typeof DashboardExperienceRoute
  DashboardJobHistoryRoute: typeof DashboardJobHistoryRoute
  DashboardLanguagesRoute: typeof DashboardLanguagesRoute
  DashboardLicenseRoute: typeof DashboardLicenseRoute
  DashboardPersonalInformationRoute: typeof DashboardPersonalInformationRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
}

const DashboardRouteRouteChildren: DashboardRouteRouteChildren = {
  DashboardEducationRoute: DashboardEducationRoute,
  DashboardExperienceRoute: DashboardExperienceRoute,
  DashboardJobHistoryRoute: DashboardJobHistoryRoute,
  DashboardLanguagesRoute: DashboardLanguagesRoute,
  DashboardLicenseRoute: DashboardLicenseRoute,
  DashboardPersonalInformationRoute: DashboardPersonalInformationRoute,
  DashboardIndexRoute: DashboardIndexRoute,
}

const DashboardRouteRouteWithChildren = DashboardRouteRoute._addFileChildren(
  DashboardRouteRouteChildren,
)

interface UserProfileRouteChildren {
  UserProfileEducationRoute: typeof UserProfileEducationRoute
  UserProfileExperienceRoute: typeof UserProfileExperienceRoute
  UserProfileLanguagesRoute: typeof UserProfileLanguagesRoute
  UserProfileLicencesRoute: typeof UserProfileLicencesRoute
  UserProfilePersonalRoute: typeof UserProfilePersonalRoute
  UserProfileIndexRoute: typeof UserProfileIndexRoute
}

const UserProfileRouteChildren: UserProfileRouteChildren = {
  UserProfileEducationRoute: UserProfileEducationRoute,
  UserProfileExperienceRoute: UserProfileExperienceRoute,
  UserProfileLanguagesRoute: UserProfileLanguagesRoute,
  UserProfileLicencesRoute: UserProfileLicencesRoute,
  UserProfilePersonalRoute: UserProfilePersonalRoute,
  UserProfileIndexRoute: UserProfileIndexRoute,
}

const UserProfileRouteWithChildren = UserProfileRoute._addFileChildren(
  UserProfileRouteChildren,
)

interface UserDigishokuProfileRouteChildren {
  UserDigishokuProfileAttachmentRoute: typeof UserDigishokuProfileAttachmentRoute
  UserDigishokuProfileEducationRoute: typeof UserDigishokuProfileEducationRoute
  UserDigishokuProfileExperienceRoute: typeof UserDigishokuProfileExperienceRoute
  UserDigishokuProfileLanguagesRoute: typeof UserDigishokuProfileLanguagesRoute
  UserDigishokuProfileIndexRoute: typeof UserDigishokuProfileIndexRoute
}

const UserDigishokuProfileRouteChildren: UserDigishokuProfileRouteChildren = {
  UserDigishokuProfileAttachmentRoute: UserDigishokuProfileAttachmentRoute,
  UserDigishokuProfileEducationRoute: UserDigishokuProfileEducationRoute,
  UserDigishokuProfileExperienceRoute: UserDigishokuProfileExperienceRoute,
  UserDigishokuProfileLanguagesRoute: UserDigishokuProfileLanguagesRoute,
  UserDigishokuProfileIndexRoute: UserDigishokuProfileIndexRoute,
}

const UserDigishokuProfileRouteWithChildren =
  UserDigishokuProfileRoute._addFileChildren(UserDigishokuProfileRouteChildren)

interface UserRouteChildren {
  UserProfileRoute: typeof UserProfileRouteWithChildren
  UserAccountEditRoute: typeof UserAccountEditRoute
  UserDigishokuDashboardRoute: typeof UserDigishokuDashboardRoute
  UserDigishokuProfileRoute: typeof UserDigishokuProfileRouteWithChildren
  UserDigishokuAccountEditRoute: typeof UserDigishokuAccountEditRoute
}

const UserRouteChildren: UserRouteChildren = {
  UserProfileRoute: UserProfileRouteWithChildren,
  UserAccountEditRoute: UserAccountEditRoute,
  UserDigishokuDashboardRoute: UserDigishokuDashboardRoute,
  UserDigishokuProfileRoute: UserDigishokuProfileRouteWithChildren,
  UserDigishokuAccountEditRoute: UserDigishokuAccountEditRoute,
}

const UserRouteWithChildren = UserRoute._addFileChildren(UserRouteChildren)

interface AuthVerificationRouteChildren {
  AuthVerificationOtpRoute: typeof AuthVerificationOtpRoute
  AuthVerificationPhoneRoute: typeof AuthVerificationPhoneRoute
  AuthVerificationSuccessRoute: typeof AuthVerificationSuccessRoute
}

const AuthVerificationRouteChildren: AuthVerificationRouteChildren = {
  AuthVerificationOtpRoute: AuthVerificationOtpRoute,
  AuthVerificationPhoneRoute: AuthVerificationPhoneRoute,
  AuthVerificationSuccessRoute: AuthVerificationSuccessRoute,
}

const AuthVerificationRouteWithChildren =
  AuthVerificationRoute._addFileChildren(AuthVerificationRouteChildren)

interface AuthRouteChildren {
  AuthSplatRoute: typeof AuthSplatRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthPhoneRoute: typeof AuthPhoneRoute
  AuthRegisterRoute: typeof AuthRegisterRoute
  AuthVerificationRoute: typeof AuthVerificationRouteWithChildren
  AuthNewPasswordTokenRoute: typeof AuthNewPasswordTokenRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthSplatRoute: AuthSplatRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthPhoneRoute: AuthPhoneRoute,
  AuthRegisterRoute: AuthRegisterRoute,
  AuthVerificationRoute: AuthVerificationRouteWithChildren,
  AuthNewPasswordTokenRoute: AuthNewPasswordTokenRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AdminV2RouteRoute: AdminV2RouteRouteWithChildren,
  AffiliateRouteRoute: AffiliateRouteRouteWithChildren,
  DashboardRouteRoute: DashboardRouteRouteWithChildren,
  UserRoute: UserRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  InviteRoute: InviteRoute,
  JobDetailJobIdRoute: JobDetailJobIdRoute,
  HomeLandingIndexRoute: HomeLandingIndexRoute,
  AboutUsIndexRoute: AboutUsIndexRoute,
  CareerPageIndexRoute: CareerPageIndexRoute,
  ProgramGijinkokuPreparationIndexRoute: ProgramGijinkokuPreparationIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
